import React, { useState, useEffect } from 'react';
import { Spin, message, Table } from 'antd';
import { Infocomponenteeconomico, servicios_publicos } from '../../../services/perfiles/conponentesServices';
import './tablaG.css';

const ServiciosPublicos = ({ municipioId }) => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]); // Datos de servicios públicos
    const [description, setDescription] = useState('');
    const [Turismo, setTurismo] = useState('');
    const [fuenteT, setfuenteT] = useState('');
    const [componente, setComponente] = useState('');
    const [fuente, setFuente] = useState('');

    useEffect(() => {
        if (municipioId) {
                  fetchData();
        fetchDataTurismo()  
        }

    }, [municipioId]);

    const fetchData = async () => {
        setLoading(true);
        try {
            const response = await servicios_publicos(municipioId);
            if (response && response.status === 200) {
                const fetchedData = response.data;
                if (Array.isArray(fetchedData)) {
                    setData(fetchedData);
                    if (fetchedData.length > 0) {
                        // Establecer la descripción, componente y fuente solo una vez
                        setDescription(fetchedData[0].descripcion);
                        setComponente(fetchedData[0].nombre_componente);
                        setFuente(fetchedData[0].fuente);
                    }
                } else {
                    throw new Error('Fetched data is not an array');
                }
            } else {
                throw new Error('Invalid response from server');
            }
        } catch (error) {
            message.error('Error loading data');
            console.error(error);
        } finally {
            setLoading(false);
        }
    };
    const fetchDataTurismo = async () => {
        setLoading(true);
        try {
            const response = await Infocomponenteeconomico(municipioId);
            if (response && response.status === 200) {
                const fetchedData = response.data;
                if (Array.isArray(fetchedData)) {
                    if (fetchedData.length > 0) {
                        setTurismo(fetchedData[0].turismo);

                    }
                } else {
                    throw new Error('Fetched data is not an array');
                }
            } else {
                throw new Error('Invalid response from server');
            }
        } catch (error) {
            message.error('Error loading data');
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    // Datos de la tabla en formato Key-Value
    const keyValueData = [
        { key: 'Municipio', value: data[0]?.municipio },
        { key: 'Cobertura Acueducto (Censo)', value: data[0]?.porc_cobert_acueducto_censo },
        { key: 'Cobertura Alcantarillado (Censo)', value: data[0]?.porc_cobert_alcantarillado_censo },
        { key: 'Cobertura Acueducto (Rec)', value: data[0]?.porc_cobertura_acueducto_rec },
        { key: 'Cobertura Alcantarillado (Rec)', value: data[0]?.porc_cobertura_alcantarillado_rec },
        { key: 'Déficit Cuantitativo', value: data[0]?.porc_deficit_cuantitativo },
        { key: 'Déficit Cualitativo', value: data[0]?.porc_deficit_cualitativo },
        { key: 'Cobertura Energía', value: data[0]?.porc_cobertura_energia },
        { key: 'Penetración Banda Ancha', value: data[0]?.porc_penetracion_banda_ancha },
    ];

    return (
        <div className="page-content">
            {loading ? (
                <Spin size="large" />
            ) : data.length > 0 ? (
                <>
                    {/* Mostrar la descripción solo una vez */}
                    <h3>Servicios Públicos</h3>
                    <p className="descripcion">{description}</p>
                    <p className="descripcion">{componente}</p>

                    {/* Mostrar la tabla con los datos Key-Value */}
                    <Table
                        dataSource={keyValueData}
                        columns={[
                            { title: 'Campo', dataIndex: 'key', key: 'key', className: 'filaP' },
                            { title: 'Valor', dataIndex: 'value', key: 'value', className: 'filaP' }
                        ]}
                        rowKey="key"
                        pagination={false}
                        bordered
                        showHeader={false}  // Ocultar los encabezados de las columnas, ya que los nombres son las claves
                    />
                    <p className="descripcion">{fuente}</p>
                    <h4>Turismo</h4>
                    <p style={{ columnCount: 2, columnGap: '30px' }}>{Turismo}</p>
                    <p >{fuenteT}</p>

                </>
            ) : (
                <p>No hay datos disponibles para este municipio.</p>
            )}
        </div>
    );
};

export default ServiciosPublicos;
